export default (type: string, name: string, params: any): void => {
  /** use global gtag function to send analytics tracking */
  if (window.gtag != null && typeof window.gtag === "function") {
    window.gtag(type, name, params);
  }
};
